// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__MhtQQ","label":"SetPasswdForm_label__3mQXk"};